import { CompanyAPI } from '@api/buser-http-client';

const simulateInvoiceCancelation = (groupId) => CompanyAPI.simulateInvoiceCancelation({ groupId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { simulateInvoiceCancelation };
